import { useEffect, useState } from 'react'
import sendMembershipEmailQuery from 'Shared/Queries/SendMembershipEmailQuery'
import { useLazyQueryNoCache } from 'Shared/Hooks/useApolloClient'
import validationSchema from './validationSchema'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import FormTextInput from 'Shared/Formik/FormTextInput'
import FormWithValidations from 'Shared/Formik/FormWithValidations'
import Loading from 'Shared/Loading'
import ResultModal from './ResultModal'
import 'Styles/SalmonHeaderModal.scss'

const ForgotMembershipModal = ({ isOpen, slug, toggle }) => {
  const [sendEmailQuery, { data, loading }] = useLazyQueryNoCache(sendMembershipEmailQuery)
  const [isResultModalOpen, setIsResultModalOpen] = useState(false)
  const modalClasses = 'membership-email-modal salmon-header-modal modal-lg p-4 no-override-footer'

  const onSubmit = values => {
    sendEmailQuery({ variables: { slug, email: values.email } })
  }

  const onToggle = () => {
    toggle()
  }

  const resultModalClose = () => {
    setIsResultModalOpen(false)
    toggle(false)
  }

  const tryAgain = () => {
    setIsResultModalOpen(false)
    toggle(true)
  }

  useEffect(() => {
    if (data && !loading) {
      setIsResultModalOpen(true)
      onToggle()
    }
  }, [data, loading])

  return (
    <>
      <Modal centered className={modalClasses} isOpen={isOpen} toggle={onToggle}>
        <FormWithValidations disableRenderProps formId="send-membership-form" initialValues={{ email: '' }}
                             onSubmit={onSubmit} validationSchema={validationSchema}>
          <ModalHeader toggle={onToggle}>
            Forgot Your Membership?
          </ModalHeader>

          <ModalBody>
            <p className="text-muted mb-3">
              We'll send your active membership details to your email. Please provide your email address below.
            </p>

            <FormTextInput className="text-gray-600 mb-3" label="Email" name="email" placeholder="Email address"
                           type="email" showErrors />
          </ModalBody>

          <ModalFooter className="pt-3">
            <Button color="outline-salmon" onClick={onToggle}>Cancel</Button>

            <Button type="submit" className="d-flex" color="salmon">
              Send Email

              {loading && <Loading className="ms-2" size="1x" />}
            </Button>
          </ModalFooter>
        </FormWithValidations>
      </Modal>

      <ResultModal data={data} isOpen={isResultModalOpen} loading={loading} toggle={resultModalClose}
                   tryAgain={tryAgain} />
    </>
  )
}

export default ForgotMembershipModal
